import styled from "@emotion/styled";
import { css } from "@emotion/react";
import colors from "../../styles/colors";
export const TrackerContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const StepWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const TrackerList = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const Step = styled.div `
  width: 2rem;
  height: 2rem;
  border-radius: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors["color-blue-180"]};
  ${(props) => getTheme(props.status, props.trackerStatus)};
  svg {
      stroke-width: 0.5px;
      stroke: ${(props) => colors[props.trackerStatus === "finished"
    ? "color-green-120"
    : "color-blue-80"]};
      fill: ${(props) => colors[props.trackerStatus === "finished"
    ? "color-green-120"
    : "color-blue-80"]}};
  }
`;
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  span {
    display: flex;
    flex-direction: row;
    justify-content: center;
    white-space: pre-line;
  }
  .timestamp {
    padding: 1.5rem 0 0 0;
    font-family: Inter;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
  }
  .description {
    gap: 0;
    .bullets {
      text-align: left;
    }
  }
`;
export const StepIconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Line = styled.div `
  width: 2rem;
  height: 0.25rem;
  position: relative;
  background-color: ${colors["color-gray-40"]};
  ${(props) => getLineColor(props.line_status, props.trackerStatus)};
`;
function getLineColor(line_status, trackerStatus) {
    if (trackerStatus === "finished") {
        return css `
      background-color: ${colors["color-green-50"]};
    `;
    }
    else {
        if (line_status === "completed") {
            return css `
        background-color: ${colors["color-blue-70"]};
      `;
        }
        else if (line_status === "in-progress") {
            return css `
        background: linear-gradient(
          90deg,
          ${colors["color-blue-70"]} 50%,
          ${colors["color-gray-40"]} 50%
        );
      `;
        }
        else if (line_status === "in-progress-warn") {
            return css `
        background: linear-gradient(
          90deg,
          ${colors["color-red-80"]} 50%,
          ${colors["color-gray-40"]} 50%
        );
      `;
        }
        else {
            return css `
        background-color: ${colors["color-gray-40"]};
      `;
        }
    }
}
function getTheme(status, trackerStatus) {
    if (trackerStatus === "finished") {
        return css `
      border: 0.156rem solid ${colors["color-green-100"]};
      }
    `;
    }
    else {
        switch (status) {
            case "active":
                return css `
          border: 0.156rem solid ${colors["color-blue-120"]};
          box-shadow: 0px 0px 0px 6px rgba(93, 140, 236, 0.25);
        `;
            case "active-warn":
                return css `
          border: 0.156rem solid ${colors["color-red-80"]};
          box-shadow: 0px 0px 0px 6px rgba(255, 138, 114, 0.25);
        `;
            case "completed":
                return css `
          border: 0.156rem solid ${colors["color-blue-80"]};
        `;
            case "disabled":
                return css `
          background-color: ${colors["color-gray-80"]};
          color: ${colors["color-white-100"]};
        `;
        }
    }
}
//# sourceMappingURL=TrackStatus.styled.js.map